import Sponsor from "../../../../src/components/Sponsor/index";
import * as React from 'react';
export default {
  Sponsor,
  React
};